/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//Instructions API list
/**
 *
 * @param {integer} id
 * @returns
 */

export function loadTeamSchedlingDetails(id) {
  return api
    .post(`/get_lead_event_service_list`, id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadTeamSchedlingServiceDetails(record) {
  return api
    .post(`/get_event_team_schedule_detils_from_lead`,record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadFreelancerListDetails(record) {
  return api
    .post(`/get_all_freelancerByServiceName`,record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadEventTeamSchedlingDetails(eventScheduling) {
  return api
    .post(`/get_all_event_team_schedule`, eventScheduling)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadAgentVacancyDetails(record) {
  return api
    .post(`/get_employee_monthly_schedule_list`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadAgentOfficeVacancyDetails(record) {
  return api
    .post(`/get_employee_month_wise_schedule_list`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadShooterHistoryDetails(empId) {
  const payload = {
    empId: empId,
  }
  return api
    .post(`/get_employe_shooter_history`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function addTeamSchedulingDetails(teamScheduling) {
 
  try {
    const response = await api.post(`/add_event_team_schedule_new`, teamScheduling)
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateTeamSchedulingServiceDetails(teamScheduling) {
 
  try {
    const response = await api.post(`/update_eventTeam_service`, teamScheduling)
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
export async function removeTeamSchedulingServiceDetails(teamScheduling) {
 
  try {
    const response = await api.post(`/update_recent_teamschedule_service`, teamScheduling)
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
export async function updateTeamSchedulingDetails(teamScheduling) {
 
  try {
    const response = await api.post(
      `/update_by_event_team_schedule_id_new`,
      teamScheduling
    )
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
export async function teamCommitDetails(finalCommit) {
 
  try {
    const response = await api.post(`/team_schedule_history`, finalCommit)
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const remotes = {
  loadRecordsMetaData,

  loadTeamSchedlingDetails,
  loadTeamSchedlingServiceDetails,
  updateTeamSchedulingServiceDetails,
  addTeamSchedulingDetails,
  updateTeamSchedulingDetails,
  loadShooterHistoryDetails,
  loadEventTeamSchedlingDetails,
  teamCommitDetails,
  loadAgentVacancyDetails,
  loadFreelancerListDetails,
  removeTeamSchedulingServiceDetails
}

export default remotes
